document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.addToCartButtonCustom').forEach(function(button) {
    button.addEventListener('click', function() {
        // Find the parent .product-card
        let productCard = this.closest('.product-card');
        // Find the submit button within the .product-card
        let submitButton = productCard.querySelector('button[type="submit"]');
        // Trigger the click on the submit button
        submitButton.click();
    });
});
});